var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 134.534,
    height: 34,
    viewBox: "0 0 134.534 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4738",
    "data-name": "Rectangle 4738",
    width: 134.534,
    height: 34,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6774",
    "data-name": "Group 6774",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6774-2",
    "data-name": "Group 6774",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1015",
    "data-name": "Path 1015",
    d: "M5.664,4.355l.225,4.707q0,2.983-2.455,2.984H2.455Q0,12.046,0,9.063V0H1.322V9.063q0,1.843,1.133,1.843h.979q1.118,0,1.125-1.843L4.327,4.355Z",
    transform: "translate(0 0)",
    fill: "#29333b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1016",
    "data-name": "Path 1016",
    d: "M12.586,9.1l-.007,1.569q0,1.843,1.14,1.843h1q1.1,0,1.1-1.843L15.8,8.745q-.007-1.28-1.622-1.618a1.854,1.854,0,0,1-1.615-2.02h1.351q0,.914,1.611,1.4a2.122,2.122,0,0,1,1.619,2.238l.007,1.928q0,2.983-2.435,2.983h-1q-2.456,0-2.47-2.983L11.256,9.1Z",
    transform: "translate(-3.53 -1.603)",
    fill: "#29333b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1017",
    "data-name": "Path 1017",
    d: "M27.07,0h1.344l-.007,12.482q.007,2.991-2.448,2.99h-.978q-2.456,0-2.463-2.99l.007-1.062h1.33l-.007,1.062q.021,1.865,1.133,1.865h.978q1.126,0,1.119-1.865L27.07,5.608H25.29q-1.2,0-1.2,1.323l.078,1.055h-1.33l-.078-1.055A2.206,2.206,0,0,1,25.29,4.475h1.78Z",
    transform: "translate(-7.066 0)",
    fill: "#29333b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    "data-name": "Path 1018",
    d: "M35.114,9.1l-.007,1.569q0,1.843,1.14,1.843h1q1.1,0,1.1-1.843l-.014-1.928q-.007-1.28-1.622-1.618a1.854,1.854,0,0,1-1.615-2.02h1.351q0,.914,1.611,1.4a2.122,2.122,0,0,1,1.619,2.238l.007,1.928q0,2.983-2.435,2.983h-1q-2.456,0-2.47-2.983L33.784,9.1Z",
    transform: "translate(-10.599 -1.603)",
    fill: "#29333b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    d: "M51.392,0q-.028,1.253-2.382,2.111T46.656,4.4a3.2,3.2,0,0,1,.69-.071h.788a1.992,1.992,0,0,1,1.759.88,1.948,1.948,0,0,1,1.724-.88h.788q2.279,0,2.28,2.527l-.078,5.2H53.249l.063-5.2q.007-1.394-.907-1.394h-.788q-1.069,0-1.09,1.344h.007v2.87H49.238V6.811q-.028-1.344-1.1-1.344h-.788q-.957,0-.964,1.394l.113,5.2H45.158l-.113-5.735q0-3.891,2.491-4.827T50.027,0Z",
    transform: "translate(-14.135 0)",
    fill: "#29333b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    d: "M64.919,14.019h-.69q-2.47,0-2.47-2.984V9.311q0-3,2.4-3h.767a1.825,1.825,0,0,1,1.815.978,2.087,2.087,0,0,1,1.619-1h.654Q71.3,6.307,71.3,9.3l-.078,4.721H69.887L69.95,9.3q.007-1.851-.922-1.858h-.683q-.928,0-.928,1.843v1.745q.007,2.99-2.5,2.99m1.175-2.99L66.1,9.3q.014-1.851-1.168-1.858h-.7Q63.1,7.44,63.1,9.3v1.731q.007,1.851,1.133,1.851h.69q1.182,0,1.175-1.851",
    transform: "translate(-19.38 -1.973)",
    fill: "#29333b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    d: "M80.588,10.8h1.3V10.8q.978-.07,1-1.773.014-1.583-1.084-1.583h-.845q-1.132,0-1.14,1.619l.008.6H78.5l-.008-.6q.007-2.759,2.47-2.759h.845q2.42,0,2.42,2.723a2.661,2.661,0,0,1-1.154,2.385,2.2,2.2,0,0,1,1.161,2.168l-.008.7q0,3.166-2.413,3.166h-1q-2.484.007-2.484-3.173v-.817h1.337v.817q0,2.047,1.147,2.048h1q1.091,0,1.077-2.041l.007-.7q-.007-1.619-1.006-1.675v.007h-1.3Z",
    transform: "translate(-24.579 -1.979)",
    fill: "#29333b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    "data-name": "Path 1022",
    d: "M89.753,9.331q.007-2.983,2.4-2.984h1q2.35,0,2.343,2.984v5.144q.007,2.99-2.435,3l-1-.007q-2.455,0-2.463-2.99V13.4h1.33l-.007,1.077q.022,1.864,1.14,1.864l1,.007q1.105-.007,1.1-1.871V9.331q-.007-1.871-1.006-1.872h-1q-1.069,0-1.077,1.872l.007.465H89.76Z",
    transform: "translate(-28.115 -1.992)",
    fill: "#29333b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    d: "M110.323,15.461q1.935,0,1.928,2.083h-1.245q0-.879-.725-.88l-6.065.008q-3.1-.007-3.117-3.054l-.078-4.489q0-2.821,2.315-2.821h.633a2.076,2.076,0,0,1,1.745.76,2.055,2.055,0,0,1,1.737-.76h.387a2.056,2.056,0,0,1,1.738.76,2.076,2.076,0,0,1,1.745-.76h.633q2.434,0,2.435,2.842l-.078,4.588H113l.057-4.588q.013-1.7-1.1-1.7h-.633q-1.1,0-1.112,1.464h.014v3.047h-1.274V8.917q-.006-1.471-1.112-1.471h-.387q-1.09,0-1.1,1.407v3.1h-1.274v-3.1q-.029-1.408-1.133-1.407h-.612q-.957,0-.985,1.681l.078,4.44q0,1.893,1.766,1.893Z",
    transform: "translate(-31.7 -1.979)",
    fill: "#29333b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    d: "M129.9,6.316h.788q2.28,0,2.28,2.526l-.078,5.193h-1.358l.063-5.193q.007-1.393-.908-1.393H129.9q-1.069,0-1.09,1.344h.007v2.871h-1.295V8.793q-.028-1.343-1.1-1.344h-.788q-.957,0-.964,1.393l.078,5.193H123.4l-.078-5.214q0-2.5,2.3-2.5h.788a1.991,1.991,0,0,1,1.759.88,1.945,1.945,0,0,1,1.724-.88",
    transform: "translate(-38.698 -1.982)",
    fill: "#29333b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1025",
    "data-name": "Path 1025",
    d: "M145.7,4.355l.225,4.707q0,2.983-2.455,2.984h-.979q-2.456,0-2.455-2.984V0h1.322V9.063q0,1.843,1.133,1.843h.979q1.118,0,1.125-1.843l-.232-4.707Z",
    transform: "translate(-43.943 0)",
    fill: "#29333b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1026",
    "data-name": "Path 1026",
    d: "M5.664,31.355l.225,4.707q0,2.983-2.455,2.984H2.455Q0,39.046,0,36.063V27H1.322v9.063q0,1.843,1.133,1.843h.979q1.118,0,1.125-1.843l-.232-4.707Z",
    transform: "translate(0 -8.473)",
    fill: "#29333b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1027",
    "data-name": "Path 1027",
    d: "M12.586,36.1l-.007,1.569q0,1.843,1.14,1.843h1q1.1,0,1.1-1.843L15.8,35.745q-.007-1.28-1.622-1.618a1.854,1.854,0,0,1-1.615-2.02h1.351q0,.914,1.611,1.4a2.122,2.122,0,0,1,1.619,2.238l.007,1.928q0,2.983-2.435,2.983h-1q-2.456,0-2.47-2.983l.007-1.569Z",
    transform: "translate(-3.53 -10.075)",
    fill: "#29333b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1028",
    "data-name": "Path 1028",
    d: "M22.517,34.339q.007-2.983,2.463-2.984h.232l.021-1.133a1.64,1.64,0,0,0-.76-1.484A1.9,1.9,0,0,1,23.713,27h1.274a1.527,1.527,0,0,0,.665,1.351q.63.387.707,1.829l-.049,1.175q2.1,0,2.1,2.984l-.006,1.724q0,3-2.428,2.99h-1q-2.456,0-2.455-2.99Zm3.463,3.574q1.083.007,1.1-1.851l.007-1.724q-.014-1.871-.788-1.872L24.98,32.46q-1.133.007-1.133,1.879v1.724q0,1.858,1.133,1.851Z",
    transform: "translate(-7.066 -8.473)",
    fill: "#29333b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1029",
    "data-name": "Path 1029",
    d: "M35.114,36.1l-.007,1.569q0,1.843,1.14,1.843h1q1.1,0,1.1-1.843l-.014-1.928q-.007-1.28-1.622-1.618a1.854,1.854,0,0,1-1.615-2.02h1.351q0,.914,1.611,1.4a2.122,2.122,0,0,1,1.619,2.238l.007,1.928q0,2.983-2.435,2.983h-1q-2.456,0-2.47-2.983l.007-1.569Z",
    transform: "translate(-10.599 -10.075)",
    fill: "#29333b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1030",
    "data-name": "Path 1030",
    d: "M45.052,29.536a2.745,2.745,0,0,1,.528-1.942,2.4,2.4,0,0,1,1.738-.528l3.152-.035v1.175L47.318,28.2q-.95,0-.95,1.337v1.809h2.111q2.456,0,2.456,3v1.724q0,2.984-2.456,2.984H47.5q-2.449,0-2.456-2.984Zm3.427,8.387q1.126-.014,1.119-1.851l.008-1.724q-.007-1.871-1.133-1.872h-2.1v3.6q.007,1.836,1.133,1.844Z",
    transform: "translate(-14.135 -8.482)",
    fill: "#29333b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    d: "M58,37.529l1.752.014v-.008a1.149,1.149,0,0,0,1.091-1.294,3.874,3.874,0,0,0-1.464-2.934h1.681a3.907,3.907,0,0,1,1.126,2.948,2,2,0,0,1-1.14,1.816,2.136,2.136,0,0,1,1.14,1.97l-.007,1.238q.013,3.173-2.413,3.174h-1q-2.47,0-2.477-3.174v-.957h1.33l.008.957q-.007,2.048,1.14,2.048h1q1.09,0,1.09-2.048l-.007-1.238q-.007-1.366-.992-1.442L58,38.605Z",
    transform: "translate(-17.665 -10.452)",
    fill: "#29333b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    d: "M74.135,33.316h.788q2.28,0,2.28,2.526l-.078,5.193H75.767l.063-5.193q.007-1.393-.908-1.393h-.788q-1.069,0-1.09,1.344h.007v2.871H71.756V35.793q-.028-1.343-1.1-1.344h-.788q-.957,0-.964,1.393l.078,5.193H67.641l-.078-5.214q0-2.5,2.3-2.5h.788a1.991,1.991,0,0,1,1.759.88,1.945,1.945,0,0,1,1.724-.88",
    transform: "translate(-21.201 -10.455)",
    fill: "#29333b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    d: "M92.289,36.1l-.007,1.569q0,1.843,1.14,1.843h1q1.1,0,1.1-1.843L95.5,35.745q-.007-1.28-1.622-1.618a1.854,1.854,0,0,1-1.615-2.02h1.351q0,.914,1.611,1.4a2.122,2.122,0,0,1,1.619,2.238l.007,1.928q0,2.983-2.435,2.983h-1q-2.456,0-2.47-2.983l.007-1.569Z",
    transform: "translate(-28.54 -10.075)",
    fill: "#29333b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    d: "M107.886,31.355l.225,4.707q0,2.983-2.455,2.984h-.979q-2.456,0-2.455-2.984V27h1.322v9.063q0,1.843,1.133,1.843h.979q1.118,0,1.125-1.843l-.232-4.707Z",
    transform: "translate(-32.077 -8.473)",
    fill: "#29333b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1035",
    "data-name": "Path 1035",
    d: "M120.042,33.316h.788q2.28,0,2.28,2.526l-.078,5.193h-1.358l.063-5.193q.007-1.393-.908-1.393h-.788q-1.069,0-1.09,1.344h.007v2.871h-1.295V35.793q-.028-1.343-1.1-1.344h-.788q-.957,0-.964,1.393l.078,5.193h-1.337l-.078-5.214q0-2.5,2.3-2.5h.788a1.991,1.991,0,0,1,1.759.88,1.945,1.945,0,0,1,1.724-.88",
    transform: "translate(-35.606 -10.455)",
    fill: "#29333b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1036",
    "data-name": "Path 1036",
    d: "M135.06,40.441q-.014-1.886-1.062-1.914h-1.063V37.373h.922v.008q.886-.007.887-1.414a3.81,3.81,0,0,0-1.21-2.66H135.1a3.6,3.6,0,0,1,.978,2.673h.007a1.841,1.841,0,0,1-1.133,1.921,2.582,2.582,0,0,1,1.436,2.491l.007.887q0,3.173-2.427,3.174h-1.295q-2.491.007-2.491-3.174V33.307h1.33v7.972q0,2.047,1.161,2.048h1.295q1.09,0,1.09-2.048Z",
    transform: "translate(-40.851 -10.452)",
    fill: "#29333b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1037",
    "data-name": "Path 1037",
    d: "M141.982,41.029l-.078-4.721q.014-2.991,2.477-2.99h1q2.434,0,2.42,2.99l-.078,4.721h-1.337l.078-4.721q.013-1.858-1.084-1.858h-1q-1.133,0-1.147,1.858l.078,4.721Z",
    transform: "translate(-44.529 -10.455)",
    fill: "#29333b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    d: "M154.52,36.1l-.007,1.569q0,1.843,1.14,1.843h1q1.1,0,1.1-1.843l-.014-1.928q-.007-1.28-1.622-1.618a1.854,1.854,0,0,1-1.615-2.02h1.351q0,.914,1.611,1.4a2.122,2.122,0,0,1,1.619,2.238l.007,1.928q0,2.983-2.435,2.983h-1q-2.456,0-2.47-2.983l.007-1.569Z",
    transform: "translate(-48.068 -10.075)",
    fill: "#29333b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    d: "M169.328,40.441q-.014-1.886-1.062-1.914H167.2V37.373h.922v.008q.886-.007.887-1.414a3.81,3.81,0,0,0-1.21-2.66h1.569a3.6,3.6,0,0,1,.978,2.673h.007a1.841,1.841,0,0,1-1.133,1.921,2.582,2.582,0,0,1,1.436,2.491l.007.887q0,3.173-2.427,3.174h-1.295q-2.491.007-2.491-3.174V33.307h1.33v7.972q0,2.047,1.161,2.048h1.295q1.09,0,1.09-2.048Z",
    transform: "translate(-51.604 -10.452)",
    fill: "#29333b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1040",
    "data-name": "Path 1040",
    d: "M176.25,41.029l-.078-4.721q.014-2.991,2.477-2.99h1q2.434,0,2.42,2.99l-.078,4.721h-1.337l.078-4.721q.013-1.858-1.084-1.858h-1q-1.133,0-1.147,1.858l.078,4.721Z",
    transform: "translate(-55.282 -10.455)",
    fill: "#29333b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1041",
    "data-name": "Path 1041",
    d: "M188.789,36.1l-.007,1.569q0,1.843,1.14,1.843h1q1.1,0,1.1-1.843L192,35.745q-.007-1.28-1.622-1.618a1.854,1.854,0,0,1-1.615-2.02h1.351q0,.914,1.611,1.4a2.122,2.122,0,0,1,1.619,2.238l.007,1.928q0,2.983-2.435,2.983h-1q-2.456,0-2.47-2.983l.007-1.569Z",
    transform: "translate(-58.821 -10.075)",
    fill: "#29333b"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoText);
export default __webpack_public_path__ + "static/media/LogoText.887382e12e81d55ed8b31a48df8a6e32.svg";
export { ForwardRef as ReactComponent };